export default __webpack_public_path__ + "files/media/home-ar-s.2622182e.jpg";